import React from 'react'
import SectionHeader from '@/components/SectionHeader'
import Button from '@/components/atoms/Button/ButtonV2'
import SectionFooter from '@/components/SectionFooter'

interface CenterCarouselFooterProps {
  (props: {
    shouldShowCta?: boolean
    headerLink?: string
    headerLinkText?: string
  }): JSX.Element | null
}

const CenterCarouselFooter: CenterCarouselFooterProps = ({
  shouldShowCta = false,
  headerLink,
  headerLinkText
}) => {
  return (
    <SectionFooter spaceClassName="xl">
      {shouldShowCta && (
        <Button
          type="tertiary"
          className="w-full md:hidden"
          as="a"
          href={headerLink}
        >
          {headerLinkText}
        </Button>
      )}
    </SectionFooter>
  )
}

export default CenterCarouselFooter
